import React from 'react';
import CV from '../../assets/cv.pdf';

const CTA = ({ t }) => {
  return (
    <div className="cta">
      <a  className="btn" href={ CV } download>{t("header-download-btn")}</a>
      <a className="btn btn-primary" href="#contact">{t("root-contact-btn")}</a>
    </div>
  )
}

export default CTA